<template>
  <div class="login-container">
    <!-- 背景装饰元素 -->
    <div class="bg-decoration">
      <div class="bg-circle bg-circle-1"></div>
      <div class="bg-circle bg-circle-2"></div>
      <div class="bg-circle bg-circle-3"></div>
    </div>

    <!-- 登录主内容区 -->
    <div class="login-main">
      <!-- 左侧品牌区域 -->
      <div class="login-brand">
        <div class="brand-logo">
          <img src="@/assets/img/login/logo.png" alt="Logo" v-if="false">
          <div class="text-logo">{{ $store.state.oem.title }}</div>
        </div>
        <div class="brand-slogan">企业级管理解决方案</div>
        <div class="brand-features">
          <div class="feature-item">
            <i class="el-icon-lock"></i>
            <span>安全可靠</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-s-promotion"></i>
            <span>高效便捷</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-data-line"></i>
            <span>智能管理</span>
          </div>
        </div>
      </div>

      <!-- 右侧登录窗口 -->
      <div class="login-box-wrapper">
        <div class="login-box">
          <!-- 登录类型切换 -->
          <div class="login-header">
            <h2 class="login-title">账号登录</h2>
            <div class="login-tabs">
              <div class="tab-item" :class="{ active: login_type === 'phone' }" @click="login_type = 'phone'">
                <i class="el-icon-mobile-phone"></i>
                <span>手机号登录</span>
              </div>
              <div class="tab-item" :class="{ active: login_type === 'account' }" @click="login_type = 'account'">
                <i class="el-icon-user"></i>
                <span>员工号登录</span>
              </div>
            </div>
          </div>
          <!-- 手机号登录表单 -->
          <div class="login-form" v-if="login_type === 'phone'">
            <div class="form-group">
              <el-input v-model="userPhone" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"
                :class="{ 'custom-input': true }" autocomplete="off"></el-input>
            </div>

            <!-- 密码/验证码登录切换 -->
            <div class="login-type-switch">
              <label class="switch-label">
                <input type="checkbox" :checked="phoneLoginType === 'sms'"
                  @change="fSwitchPhoneLoginType($event.target.checked ? 'sms' : 'password')">
                <span class="switch-text">{{ phoneLoginType === 'password' ? '使用验证码登录' : '使用密码登录' }}</span>
              </label>
            </div>

            <!-- 密码输入 -->
            <div class="form-group" v-if="phoneLoginType === 'password'">
              <el-input v-model="userPsw" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
                :class="{ 'custom-input': true }" show-password autocomplete="new-password"></el-input>
            </div>

            <!-- 验证码输入 -->
            <div class="form-group" v-else>
              <div class="code-input-wrapper">
                <el-input v-model="userPsw" placeholder="请输入验证码" prefix-icon="el-icon-chat-line-square"
                  :class="{ 'custom-input': true, 'code-input': true }" autocomplete="new-password"></el-input>
                <el-button type="primary" :disabled="!canGetCode || !userPhone || !fValidatePhone(userPhone)"
                  class="code-btn" @click="fGetCode"
                  :class="{ 'disabled-btn': !canGetCode || !userPhone || !fValidatePhone(userPhone) }"
                  style="width: 120px; height: 36px; padding: 0; font-size: 14px;">
                  {{ codeText }}
                </el-button>
              </div>
            </div>
          </div>

          <!-- 员工号登录表单 -->
          <div class="login-form" v-if="login_type === 'account'">
            <div class="form-group">
              <el-input v-model="orgId" placeholder="请输入机构号" prefix-icon="el-icon-office-building"
                :class="{ 'custom-input': true }" autocomplete="off"></el-input>
            </div>
            <div class="form-group">
              <el-input v-model="userPhone" placeholder="请输入员工工号" prefix-icon="el-icon-user"
                :class="{ 'custom-input': true }" autocomplete="off"></el-input>
            </div>
            <div class="form-group">
              <el-input v-model="userPsw" type="password" placeholder="请输入员工密码" prefix-icon="el-icon-lock"
                :class="{ 'custom-input': true }" show-password autocomplete="new-password"></el-input>
            </div>
          </div>

          <!-- 登录选项 -->
          <div class="login-options">
            <div class="remember-options">
              <el-checkbox v-model="rememberPsw" :class="{ 'custom-checkbox': true }"></el-checkbox>
              <span class="remember-text">记住密码</span>
            </div>
            <div class="forgot-password" @click="fForgotPassword">忘记密码?</div>
          </div>

          <!-- 登录按钮 -->
          <el-button type="primary" class="login-btn" @click="fLogin" :loading="isLogging">
            登录
          </el-button>

          <!-- 协议同意 -->
          <div class="agreement-section">
            <!-- {{test}} -->
            <el-checkbox v-model="isReadUserAgreement" :class="{ 'custom-checkbox': true }"></el-checkbox>
            <span class="agreement-text">
              我已阅读并同意<a href="#" @click.prevent="fToUserAgreement">《服务协议》</a>和<a href="#"
                @click.prevent="fToPrivacyPolicy">《隐私政策》</a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 语言切换 -->
    <div class="language-switcher">
      <el-dropdown trigger="click">
        <span class="language-text">{{ langLabel }} <i class="el-icon-arrow-down"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in langList" :key="index" @click="fChgLng(item)">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 页脚 -->
    <div class="login-footer">
      <p>© 2025 {{ $store.state.oem.title }}管理系统 版权所有</p>
    </div>
  </div>
</template>

<script>
import test from '../../static/test.json'
export default {
  data() {
    return {
      // 登录类型: 'phone' 手机号登录, 'account' 账号登录
      login_type: 'phone',
      // 手机号登录方式: 'password' 密码登录, 'sms' 验证码登录
      phoneLoginType: 'password',
      // 是否记住密码
      rememberPsw: true,
      // 是否显示密码
      showPassword: false,
      // 是否阅读用户协议
      isReadUserAgreement: true,
      // 是否正在登录中
      isLogging: false,
      // 机构号
      orgId: '',
      // 手机号/员工工号
      userPhone: '',
      // 密码/验证码
      userPsw: '',
      // 临时存储不同登录方式的输入值
      tempLoginInfo: {
        phone: {
          userPhone: '',
          userPsw: ''
        },
        account: {
          orgId: '',
          userPhone: '',
          userPsw: ''
        }
      },
      // 是否是组件初始化阶段
      isInitializing: true,
      // 验证码相关
      codeText: '获取验证码',
      canGetCode: true,
      codeTimer: null,
      codeCount: 60,
      // 请求ID（验证码登录时使用）
      reqId: '',
      // 语言相关
      langLabel: '中文',
      langList: [{
        label: '中文',
        value: 'zh-CN'
      },
      {
        label: 'English',
        value: 'en'
      }
      ],
      test: {},
    };
  },

  created() {
    // 从localStorage读取记住的登录信息
    this.fGetRememberInfo();
    // 初始化完成
    this.$nextTick(() => {
      this.isInitializing = false;
      console.log(test)
      this.test = test
    });
  },

  beforeDestroy() {
    // 清除定时器
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
    }
  },

  watch: {
    /**
     * 切换登录类型时保存和恢复输入值
     */
    login_type(newType, oldType) {
      // 只有在非初始化阶段才保存和恢复值
      if (this.isInitializing) return;

      // 保存当前登录方式的输入值
      if (oldType === 'phone') {
        this.tempLoginInfo.phone.userPhone = this.userPhone;
        this.tempLoginInfo.phone.userPsw = this.userPsw;
      } else if (oldType === 'account') {
        this.tempLoginInfo.account.orgId = this.orgId;
        this.tempLoginInfo.account.userPhone = this.userPhone;
        this.tempLoginInfo.account.userPsw = this.userPsw;
      }

      // 清空当前所有输入
      this.orgId = '';
      this.userPhone = '';
      this.userPsw = '';

      // 恢复目标登录方式的输入值
      if (newType === 'phone') {
        this.userPhone = this.tempLoginInfo.phone.userPhone || '';
        this.userPsw = this.tempLoginInfo.phone.userPsw || '';
      } else if (newType === 'account') {
        this.orgId = this.tempLoginInfo.account.orgId || '';
        this.userPhone = this.tempLoginInfo.account.userPhone || '';
        this.userPsw = this.tempLoginInfo.account.userPsw || '';
      }
    }
  },

  methods: {
    /**
     * 从localStorage获取记住的登录信息
     */
    fGetRememberInfo() {
      const rememberInfo = localStorage.getItem('smCloudLoginInfo');
      if (rememberInfo) {
        try {
          const info = JSON.parse(rememberInfo);
          // 总是恢复记住密码的勾选状态
          this.rememberPsw = info.rememberPsw || false;

          // 先保存当前的登录信息到tempLoginInfo，然后再修改login_type
          this.tempLoginInfo.phone.userPhone = info.phoneLoginType ? info.userPhone || '' : this.tempLoginInfo.phone
            .userPhone;
          this.tempLoginInfo.phone.userPsw = info.phoneLoginType ? (this.rememberPsw ? info.userPsw || '' : '') : this
            .tempLoginInfo.phone.userPsw;

          this.tempLoginInfo.account.orgId = info.login_type === 'account' ? info.orgId || '' : this.tempLoginInfo
            .account.orgId;
          this.tempLoginInfo.account.userPhone = info.login_type === 'account' ? info.userPhone || '' : this
            .tempLoginInfo.account.userPhone;
          this.tempLoginInfo.account.userPsw = info.login_type === 'account' ? (this.rememberPsw ? info.userPsw ||
            '' : '') : this.tempLoginInfo.account.userPsw;

          // 恢复登录类型和相关信息
          this.login_type = info.login_type || 'phone';

          // 根据登录类型设置当前界面的值
          if (this.login_type === 'account') {
            this.orgId = info.orgId || '';
            this.userPhone = info.userPhone || '';
            this.userPsw = this.rememberPsw ? info.userPsw || '' : '';
          } else if (this.login_type === 'phone') {
            this.phoneLoginType = info.phoneLoginType || 'password';
            this.userPhone = info.userPhone || '';
            this.userPsw = this.rememberPsw ? info.userPsw || '' : '';
          }

          // 恢复协议勾选状态
          this.isReadUserAgreement = info.isReadUserAgreement !== undefined ? info.isReadUserAgreement : true;
        } catch (e) {
          console.error('读取登录信息失败:', e);
        }
      }
    },

    /**
     * 保存登录信息到localStorage
     */
    fSaveRememberInfo() {
      const info = {
        rememberPsw: this.rememberPsw,
        login_type: this.login_type,
        phoneLoginType: this.phoneLoginType,
        orgId: this.orgId || '',
        userPhone: this.userPhone || '',
        userPsw: this.rememberPsw ? this.userPsw : '',
        isReadUserAgreement: this.isReadUserAgreement
      };
      localStorage.setItem('smCloudLoginInfo', JSON.stringify(info));
    },

    /**
     * 切换手机号登录方式
     */
    fSwitchPhoneLoginType(type) {
      this.phoneLoginType = type;
      this.userPsw = '';
    },

    /**
     * 获取验证码
     */
    async fGetCode() {
      if (!this.canGetCode || !this.userPhone) return;

      // 手机号格式验证
      if (!this.fValidatePhone(this.userPhone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }

      // 禁用按钮并开始倒计时
      this.canGetCode = false;
      this.codeText = `${this.codeCount}秒后重新获取`;

      this.codeTimer = setInterval(() => {
        this.codeCount--;
        if (this.codeCount <= 0) {
          clearInterval(this.codeTimer);
          this.codeText = '获取验证码';
          this.canGetCode = true;
          this.codeCount = 60;
        } else {
          this.codeText = `${this.codeCount}秒后重新获取`;
        }
      }, 1000);

      // 调用发送验证码接口
      try {
        const res = await this.fSendSysSms();
        if (res.result !== 'sucess') {
          // 失败时重置定时器
          clearInterval(this.codeTimer);
          this.codeText = '获取验证码';
          this.canGetCode = true;
          this.codeCount = 60;
          this.$message.error(res.msg);
        } else {
          this.reqId = res.req_id;
          this.$message.success('验证码发送成功');
        }
      } catch (error) {
        // 异常时重置定时器
        clearInterval(this.codeTimer);
        this.codeText = '获取验证码';
        this.canGetCode = true;
        this.codeCount = 60;
        this.$message.error('发送验证码失败，请稍后重试');
      }
    },

    /**
     * 手机号格式验证
     */
    fValidatePhone(phone) {
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(phone);
    },

    /**
     * 登录方法
     */
    async fLogin() {
      // 表单验证
      if (!this.fValidateForm()) {
        return;
      }

      // 协议勾选验证
      if (!this.isReadUserAgreement) {
        this.$message.error('请阅读并同意服务协议');
        return;
      }

      try {
        this.isLogging = true;
        // 调用登录接口
        const res = await this.fOrgUserLogin();

        if (res.result !== 'sucess') {
          this.$message.error(res.msg);
          return;
        }

        // 保存登录信息
        this.fSaveLoginInfo(res);

        // 保存记住密码信息
        this.fSaveRememberInfo();

        // 跳转到首页
        this.$router.push('/home');
      } catch (error) {
        this.$message.error('登录失败，请稍后重试');
      } finally {
        this.isLogging = false;
      }
    },

    /**
     * 表单验证
     */
    fValidateForm() {
      // 账号登录验证
      if (this.login_type === 'account') {
        if (!this.orgId) {
          this.$message.error('请输入机构号');
          return false;
        }
        if (!this.userPhone) {
          this.$message.error('请输入员工工号');
          return false;
        }
        if (!this.userPsw) {
          this.$message.error('请输入员工密码');
          return false;
        }
      }
      // 手机号密码登录验证
      else if (this.login_type === 'phone' && this.phoneLoginType === 'password') {
        if (!this.userPhone) {
          this.$message.error('请输入正确的手机号');
          return false;
        }
        if (!this.userPsw) {
          this.$message.error('请输入密码');
          return false;
        }
      }
      // 手机号验证码登录验证
      else if (this.login_type === 'phone' && this.phoneLoginType === 'sms') {
        if (!this.fValidatePhone(this.userPhone)) {
          this.$message.error('请输入正确的手机号');
          return false;
        }
        if (!this.userPsw) {
          this.$message.error('请输入验证码');
          return false;
        }
        if (!this.reqId) {
          this.$message.error('请重新获取验证码');
          return false;
        }
      }
      return true;
    },

    /**
     * 调用登录接口
     */
    async fOrgUserLogin() {
      let mchId = '';
      let js = {};

      if (this.login_type === 'account') {
        js["OPER"] = 'USER_PSW';
        js['ORG_ID'] = this.orgId;
        mchId = this.orgId;
      } else if (this.login_type === 'phone' && this.phoneLoginType === 'sms') {
        js["OPER"] = 'PHONE_SMS';
        js['ORG_ID'] = this.reqId;
        mchId = '320250710';
      } else if (this.login_type === 'phone' && this.phoneLoginType === 'password') {
        js["OPER"] = 'PHONE_PSW';
        js['ORG_ID'] = '320250710';
        mchId = '320250710';
      }

      js['USER_ID'] = this.userPhone;
      js["USER_PSW"] = this.userPsw;

      return await this.api.smCloud.fSmCloudAdminApi({
        methodName: 'ORG_USER_LOGIN',
        js: js,
        signType: 'MD5',
        mchId: '320250710',
        userId: '320250710',
        sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
        sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
      });
    },

    /**
     * 发送短信验证码接口
     */
    async fSendSysSms() {
      let js = {};
      js["OPER"] = 'ORG_USER_LOGIN';
      js["PHONE_NO"] = this.userPhone;

      return await this.api.smCloud.fSmCloudAdminApi({
        methodName: 'SEND_SYS_SMS',
        js: js,
        signType: 'MD5',
        mchId: '320250710',
        userId: '320250710',
        sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
        sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
      });
    },

    /**
     * 保存登录信息到store
     */
    fSaveLoginInfo(res) {
      this.$store.commit('setState', {
        key: 'org_id',
        value: res.user_info.org_id
      });
      this.$store.commit('setState', {
        key: 'org_name',
        value: res.user_info.org_name
      });
      this.$store.commit('setState', {
        key: 'user_id',
        value: res.user_info.user_id
      });
      this.$store.commit('setState', {
        key: 'user_name',
        value: res.user_info.user_name
      });
      this.$store.commit('setState', {
        key: 'smCloudToken',
        value: res.token
      });
      this.$store.commit('setState', {
        key: 'auth_ja',
        value: res.org_info.auth_ja
      });
      this.$store.commit('setState', {
        key: 'user_auth',
        value: res.user_auth
      });
      this.$store.commit('smCloudToken', res.token);
    },

    /**
     * 跳转到用户协议
     */
    fToUserAgreement() {
      this.$message.info('服务协议页面');
    },

    /**
     * 跳转到隐私政策
     */
    fToPrivacyPolicy() {
      this.$message.info('隐私政策页面');
    },

    /**
     * 忘记密码
     */
    fForgotPassword() {
      this.$message.info('忘记密码页面');
    },

    /**
     * 切换语言
     */
    fChgLng(item) {
      this.langLabel = item.label;
      this.$message.info(`切换到${item.label}`);
    }
  }
};
</script>

<style lang="less" scoped>
// 全局样式重置
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

// 基础布局样式
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

// 背景装饰
.bg-decoration {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  filter: blur(60px);
}

.bg-circle-1 {
  width: 500px;
  height: 500px;
  top: -200px;
  right: -200px;
}

.bg-circle-2 {
  width: 400px;
  height: 400px;
  bottom: -150px;
  left: -150px;
}

.bg-circle-3 {
  width: 300px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

// 主内容区域
.login-main {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  z-index: 1;
}

// 品牌区域
.login-brand {
  flex: 0 0 400px;
  color: white;
  padding-right: 80px;
  opacity: 0;
  transform: translateX(-50px);
  animation: fadeInLeft 0.8s ease-out forwards;
}

@keyframes fadeInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.brand-logo {
  margin-bottom: 20px;
}

.text-logo {
  font-size: 48px;
  font-weight: 700;
  letter-spacing: -1px;
}

.text-logo-accent {
  color: #4CAF50;
}

.brand-slogan {
  font-size: 18px;
  margin-bottom: 40px;
  opacity: 0.9;
  line-height: 1.6;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.feature-item:hover {
  opacity: 1;
}

.feature-item i {
  font-size: 20px;
  margin-right: 12px;
  color: #4CAF50;
}

// 登录框容器
.login-box-wrapper {
  flex: 0 0 420px;
  opacity: 0;
  transform: translateX(50px);
  animation: fadeInRight 0.8s ease-out 0.2s forwards;
}

@keyframes fadeInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.login-box {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.95);
}

// 登录头部
.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.login-tabs {
  display: flex;
  justify-content: center;
  gap: 40px;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 0;
  color: #666;
  font-size: 16px;
  transition: all 0.3s;
  position: relative;
}

.tab-item:hover {
  color: #4b6cb7;
}

.tab-item.active {
  color: #4b6cb7;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #4b6cb7;
  border-radius: 1px;
}

// 表单样式
.login-form {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.custom-input .el-input__inner {
  height: 50px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 0 15px;
  font-size: 15px;
  transition: all 0.3s;
  background-color: #fafafa;
}

.custom-input .el-input__inner:focus {
  border-color: #4b6cb7;
  box-shadow: 0 0 0 3px rgba(75, 108, 183, 0.1);
  background-color: white;
}

.custom-input .el-input__prefix {
  left: 15px;
}

// 登录方式切换
.login-type-switch {
  margin-bottom: 20px;
}

.switch-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #4b6cb7;
}

.switch-label input[type="checkbox"] {
  margin-right: 8px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

// 验证码输入区域
.code-input-wrapper {
  display: flex;
  gap: 12px;
}

.code-input {
  flex: 1;
}

.code-btn {
  min-width: 120px;
  height: 50px;
  border-radius: 8px;
  font-size: 14px;
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  border: none;
  transition: all 0.3s;
}

.code-btn:hover:not(.disabled-btn) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(75, 108, 183, 0.3);
  background: linear-gradient(135deg, #5a7bc8 0%, #253c6e 100%);
}

.disabled-btn {
  background: #e0e0e0;
  color: #999;
  cursor: not-allowed;
}

// 登录选项
.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.remember-options {
  display: flex;
  align-items: center;
}

.custom-checkbox {
  --el-checkbox-size: 16px;
}

.remember-text {
  margin-left: 8px;
  font-size: 14px;
  color: #666;
}

.forgot-password {
  font-size: 14px;
  color: #4b6cb7;
  cursor: pointer;
  transition: color 0.3s;
}

.forgot-password:hover {
  color: #182848;
  text-decoration: underline;
}

// 登录按钮
.login-btn {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  border: none;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.login-btn:hover::before {
  left: 100%;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(75, 108, 183, 0.3);
  background: linear-gradient(135deg, #5a7bc8 0%, #253c6e 100%);
}

.login-btn:active {
  transform: translateY(0);
}

// 协议部分
.agreement-section {
  display: flex;
  align-items: center;
  margin-top: 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.agreement-text {
  margin-left: 8px;
}

.agreement-text a {
  color: #4b6cb7;
  text-decoration: none;
}

.agreement-text a:hover {
  text-decoration: underline;
}

// 语言切换器
.language-switcher {
  position: absolute;
  top: 20px;
  right: 40px;
  z-index: 10;
}

.language-text {
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s;
}

.language-text:hover {
  background: rgba(255, 255, 255, 0.2);
}

// 页脚
.login-footer {
  text-align: center;
  padding: 20px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  position: relative;
  z-index: 1;
}

// 响应式设计
@media (max-width: 992px) {
  .login-brand {
    display: none;
  }

  .login-main {
    padding: 20px;
  }

  .login-box-wrapper {
    flex: 0 0 100%;
    max-width: 400px;
  }
}

@media (max-width: 480px) {
  .login-box {
    padding: 30px 20px;
    margin: 10px;
  }

  .login-tabs {
    gap: 20px;
  }

  .code-input-wrapper {
    flex-direction: column;
  }

  .code-btn {
    min-width: auto;
  }

  .login-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .language-switcher {
    top: 10px;
    right: 20px;
  }

  .bg-circle-1,
  .bg-circle-2,
  .bg-circle-3 {
    transform: scale(0.7);
  }
}

.el-dropdown-menu {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue